import { Link } from "react-router-dom";
import RightDocSidebar from "../../components/RightSidebar";

import Portions from "../../components/Banquet Setup Module/Portions";
import ServiceCards from "../../components/Banquet Setup Module/ServiceCards";
import Occasions from "../../components/Banquet Setup Module/Occasions";
import DocNavigation from "../../components/DocNavigation";

export default function BanquetSetup() {
  const sidebarSections = [
    {
      title: "1. Portions",
      items: [{ id: "portions", label: "Portions Setup" }],
    },
    {
      title: "2. Service Cards",
      items: [{ id: "service-cards", label: "Service Cards Setup" }],
    },
    {
      title: "3. Occasions",
      items: [{ id: "occasions", label: "Occasions Setup" }],
    },
  ];

  return (
    <div className="flex gap-12">

      {/* MAIN CONTENT */}
      <div className="flex-1 space-y-16">

        {/* COMMON HERO — SAME ACROSS ALL PAGES */}
        <section className="bg-white rounded-xl border border-slate-200 p-10">
          <h1 className="text-2xl font-bold text-slate-900 mb-4">
            Banquet Setup Module
          </h1>
          <p className="text-md text-slate-600 max-w-3xl">
            The Banquet Setup module allows administrators to configure core
            operational elements such as halls, services, and event occasions.
            These configurations form the foundation for bookings and reports.
          </p>
        </section>

        {/* COMPONENT SECTIONS */}
        <Portions />
        <ServiceCards />
        <Occasions />
{/* 
        NEXT */}
        {/* <section className="border-t pt-8 mt-12">
          <p className="text-slate-600">
            Next, continue to the{" "}
            <Link
              to="/docs/online-reservations"
              className="font-medium text-[#C9A24E]"
            >
              Online Reservation Module.
            </Link>{" "}
          </p>
        </section> */}
           <DocNavigation
          previous={{
            title: "Report Module",
            link: "/docs/reports"
          }}
          next={{
            title: "Expenses Module",
            link: "/docs/expenses"
          }}
        />
      </div>

      {/* RIGHT SIDEBAR */}
      <RightDocSidebar groups={sidebarSections} />
    </div>
  );
}
